<template>
  <div
    class="questions"
    data-qa="questions">
    <div class="questions-col-1">
      <QuestionCard
        v-for="(questionItem, questionItemIndex) in items"
        :key="`question-${questionItemIndex}-${questionItem.particpantOrganizationId}`"
        class="questions-item"
        :class="{'active': activeItemId === questionItem.particpantOrganizationId}"
        :data-qa="`question-${questionItemIndex}`"
        :item="questionItem"
        :show-button="false"
        @openChat="val => $emit('update:itemId', val)"/>
    </div>
    <div class="questions-col-2">
      <ChatTemplate
        :chat="!tender.hasRoute"
        :disabled="!tender || !tender.tenderId"
        file-show
        :files.sync="files"
        :loading="loading"
        :text.sync="text"
        @send="send">
        <div
          v-if="activeChat.particpantOrganizationId"
          :key="`org-info-${activeChat.particpantOrganizationId}`"
          slot="title"
          class="flex width-100">
          <UserIcon
            :key="`user-icon-${activeChat.particpantOrganizationId}`"
            :name="activeChat.particpantOrganizationTitle"
            size="38"/>
          <div
            :key="`particpantOrganizationTitle-${activeChat.particpantOrganizationTitle}`"
            class="questions-head-title"
            data-qa="particpantOrganizationTitle">
            {{ activeChat.particpantOrganizationTitle }}
          </div>
        </div>
        <template v-slot:items>
          <QuestionsChat
            :key="`questions-chat-${activeChat.particpantOrganizationId}`"
            :access-edit="user.email === 'MEDVEDEV@IT.UA'"
            class="width-100"
            :item="activeChat"
            :show="show"
            @edit="val => questionId = val.questionId"/>
        </template>
      </ChatTemplate>
    </div>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import ChatTemplate from 'components/common/blocks/history/ChatTemplate.vue'
import QuestionCard from 'components/common/blocks/questions/QuestionCard.vue'
import QuestionsChat from 'components/common/blocks/questions/QuestionsChat.vue'
import { mapGetters } from 'vuex'
import { debounce } from 'toolkit/utils/util'
import ApplicationApi from '@/api/applicationApi'
import { QuestionFile } from '@/types/commonFile.js'
const api = new ApplicationApi()

/**
 * Вопросы к поставщикам
 */
export default {
  name: 'dialogQuestions',
  data() {
    return {
      files: [],
      text: '',
      loading: false,
      questionAuthorIndex: 0,
      questionId: null,
    }
  },
  methods: {
    send: debounce(async function (value) {
      this.loading = true
      const result = this.$_.cloneDeep(this.items)
      const questions = result.find(i => i.particpantOrganizationId === this.activeItemId).questions
      const particpant = this.$_.cloneDeep(questions[questions.length - 1].particpantContact)
      particpant.answers = []
      const forma = {
        message: value,
        userIds: [particpant.addedContact.participantUserId],
      }
      await api.addOrChangeQuestion(this.tender.tenderId, this.questionId, forma, this.files)
        .then(res => {
          if (res && res.success) {
            this.loading = false
            if (!this.questionId) {
              const attachments = []
              res.attachments.forEach(element => {
                attachments.push(new QuestionFile(element))
              })

              questions.push({
                message: value,
                modifiedDate: new Date(),
                sendTime: new Date(),
                questionId: res.questionId,
                attachments: attachments,
                orgContact: {
                  contactName: this.user.name,
                  organizationId: this.stored_current_organization.organizationItId,
                },
                particpantContact: particpant
              })
            } else {
              questions.find(i => i.questionId === this.questionId).message = value
            }
            this.$emit('update:items', result)
          } else {
            this.$notice.warning({
              title: this.$t('Common.ErrorTitle'),
              message: res?.message || this.$t('Errors.STHWrong'),
              dangerouslyUseHTMLString: true,
            })
          }
        })
        .finally(() => {
          this.files = []
          this.loading = false
        })
    }, 200),
  },
  computed: {
    ...mapGetters({
      stored_current_organization: 'getCurrentOrganization',
      user: 'GET_USER',
    }),
    activeItemId() {
      return this.itemId ? this.itemId : this.items[0].particpantOrganizationId
    },
    activeChat() {
      return this.items.find(i => i.particpantOrganizationId === this.activeItemId) || {}
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          setTimeout(() => {
            const itemActive = document.getElementsByClassName('questions-item active')
            if (itemActive?.length) {
              itemActive[0].scrollIntoView({block: 'center', behavior: 'smooth'})
            }
          }, 250)
        }
      }
    }
  },
  created() {
    const itemActive = document.getElementsByClassName('questions-item active')
    if (itemActive?.length) {
      itemActive[0].scrollIntoView({block: 'center', behavior: 'smooth'})
    }
  },
  props: {
    items: {
      type: Array
    },
    itemId: {
      type: [String, Number]
    },
    show: {
      type: Boolean
    },
    tender: {
      type: Object
    },
  },
  components: {
    UserIcon,
    ChatTemplate,
    QuestionCard,
    QuestionsChat
  }
}
</script>
<style scoped>
.questions {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 100%;
  overflow: auto;
}
.questions-col-1 {
  width: 25%;
  min-width: 100px;
  overflow: auto;
  height: 100%;
}
.questions-col-2 {
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  display: flex;
  position: relative;
  flex-wrap: wrap;
  border-radius: 8px;
  align-content: flex-start;
  align-content: space-between;
  background: var(--v-main__light_green-base);
  width: calc(75% - 10px);
}

.questions-head-title {
  margin: auto 0 auto 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}
.questions-item {
  background: var(--v-secondary__green_chosen-base);
  transition: all 0.25s ease;
}
.questions-item:hover,
.questions-item:focus,
.questions-item.active {
  background: var(--v-main__light_green-base);
}
</style>
